/* Shopify UI for Martin Haranta's 2026-09-30 routing table — cinematic redesign 2026-10-04.
 * Flow: intro → sex → feeling (coded sky + orb) → age → tree questions → 2 s analysis → email → results.
 * Routing stays in engine.js; this file only renders. No health answers, age, sex or email go to analytics.
 */
(function () {
  'use strict';
  var tree = window.__qzTree;
  var quiz = document.querySelector('.ip-quiz');
  if (!tree || !quiz) return;
  var P = window.IP_QUIZ_PRODUCTS || {};
  var COPY = window.IP_QUIZ_COPY || { rows: {}, lines: {}, moods: [], ui: {}, subs: {} };
  var LABELS = window.IP_QUIZ_LABELS || { questions: {}, answers: {} };
  var UI_LABELS = {"Trávenie": "Trávení", "Koža, alergie a imunita": "Kůže, alergie a imunita", "Ženské zdraví": "Ženské zdraví", "Srdce a metabolizmus": "Srdce a metabolismus", "Trávenie, koža, imunita, srdce či ženské zdravie": "Trávení, kůže, imunita, srdce či ženské zdraví", "Mikrobióm, imunita a energia": "Mikrobiom, imunita a energie", "Výkon, regenerácia a imunita": "Výkon, regenerace a imunita", "Počas kúry antibiotík": "Během kúry antibiotik", "Analýza mikrobiómu a jedálniček na mieru": "Analýza mikrobiomu a jídelníček na míru", "Komplexný pohľad na váš mikrobióm": "Komplexní pohled na váš mikrobiom", "Srdce a metabolizmus po 50-ke": "Srdce a metabolismus po padesátce", "Vitalita v zrelom veku": "Vitalita ve zralém věku", "životný štýl a dlhovekosť": "životní styl a dlouhověkost", "šport a metabolizmus": "sport a metabolismus", "antibiotiká": "antibiotika", "strava na mieru": "strava na míru", "viacero ťažkostí naraz": "více potíží najednou", "srdce a metabolizmus": "srdce a metabolismus", "energia": "energie", "zdravie čriev": "zdraví střev", "dlhodobé zdravie": "dlouhodobé zdraví", "imunita": "imunita", "metabolizmus a výkon": "metabolismus a výkon", "regenerácia": "regenerace"};
  function questionLabel(s) { return (LABELS.questions || {})[s] || s; }
  function answerLabel(s) { return (LABELS.answers || {})[s] || s; }
  function uiLabel(s) { return UI_LABELS[s] || s; }
  var KEY = 'ip_quiz_martin_20261006_cz';
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PORTIONS_Q = 'Koľko porcií ovocia a zeleniny prijímate denne?';
  function fresh(stage) { return { stage: stage || 'intro', profile: {}, path: [], profileStep: 0 }; }
  var state = fresh();
  var timer, sky, ana, figsCur, anaRaf = 0, anaTimers = [];
  var screens = ['intro', 'screen', 'email', 'loading', 'results'];
  var el = {};
  screens.forEach(function (id) { el[id] = quiz.querySelector('#ipq-' + id); });
  var main = quiz.querySelector('#ipq-main');
  var progress = quiz.querySelector('#ipq-progress');

  /* ------------------------------------------------------------ data maps */
  var ACCENT = { 'hit-na-traveni': '#9b82d4', imunobiom: '#c8951a', allergic: '#3a9bd4', ladybiom: '#c14b7a', cardiobiom: '#cf2e2a', vitalbiom: '#7d8a24',
    sportbiom: '#e0712a', 'omega-3': '#cf9a2e', mikrobiom: '#15968f', powerbiom: '#26305f', 'iprobio-2-0': '#1a547a', 'iplan-komplexny-servis-vasho-crevneho-mikrobiomu': '#1a547a' };
  var GOALS = {
    'Chcem riešiť svoj zdravotný problém': ['stethoscope', 'Trávenie, koža, imunita, srdce či ženské zdravie', '#17a19e'],
    'Chcem zlepšiť svoj životný štýl a zapracovať na dlhovekosti (prevencia)': ['plant', 'Mikrobióm, imunita a energia', '#3fae8c'],
    'Chcem pracovať na svojom športovom výkone a metabolizme': ['person-simple-run', 'Výkon, regenerácia a imunita', '#e0712a'],
    'Užívam ATB a chcem obmedziť ich vedľajšie účinky': ['pill', 'Počas kúry antibiotík', '#9b82d4'],
    'Chcem zistiť, aké potraviny sú vhodné pre môj unikátny mikrobióm': ['bowl-food', 'Analýza mikrobiómu a jedálniček na mieru', '#1a547a'],
    'Mám viacero zdravotných problémov súčasne a chcem to najlepšie pre môj mikrobióm': ['squares-four', 'Komplexný pohľad na váš mikrobióm', '#1a547a'],
    'Chcem zapracovať na prevencií chronických ochorení (srdcovocievne, metabolické, a pod.)': ['heartbeat', 'Srdce a metabolizmus po 50-ke', '#cf2e2a'],
    'Chcem mať viac energie.': ['lightning', 'Vitalita v zrelom veku', '#7d8a24']
  };
  var GROUPS = [
    ['Trávenie', '#9b82d4', ['Zápcha', 'Tráviace problémy — hnačka, nafukovanie, pálenie záhy, syndróm dráždivého čreva', 'Histamínová intolerancia', 'SIBO', 'Priepustné črevo', 'Celiakia', 'Ulcerózna kolitída a Crohnova choroba (IBD)', 'Laktózová intolerancia', 'Cestovateľská hnačka']],
    ['Koža, alergie a imunita', '#3a9bd4', ['Koža — ekzém (atopická dermatitída), psoriáza, zápaly', 'Alergie — senná nádcha, astma…', 'Imunita — časté infekcie dýchacieho traktu aj črevné', 'Únava']],
    ['Ženské zdraví', '#c14b7a', ['Opakované bakteriálne a kvasinkové vaginózy', 'Osteoporóza a osteopénia', 'PMS, bolesti pri menštruácií alebo ovulácií', 'Endometrióza', 'Hormonálne výkyvy']],
    ['Srdce a metabolizmus', '#cf2e2a', ['Vysoký cholesterol', 'Srdcovocievne zdravie', 'Ateroskleróza', 'Metabolický syndróm', 'Diabetes 2 typu', 'Inzulínová rezistencia', 'Poruchy pečene', 'Tukový metabolizmus']]
  ];
  var ICONS = {
    'Zápcha': 'hourglass-medium', 'Tráviace problémy — hnačka, nafukovanie, pálenie záhy, syndróm dráždivého čreva': 'waves', 'Histamínová intolerancia': 'wine', 'SIBO': 'circles-four',
    'Priepustné črevo': 'shield-check', 'Celiakia': 'grains-slash', 'Ulcerózna kolitída a Crohnova choroba (IBD)': 'flame', 'Laktózová intolerancia': 'drop', 'Cestovateľská hnačka': 'airplane-tilt',
    'Koža — ekzém (atopická dermatitída), psoriáza, zápaly': 'hand-heart', 'Alergie — senná nádcha, astma…': 'flower-tulip', 'Imunita — časté infekcie dýchacieho traktu aj črevné': 'shield-plus', 'Únava': 'battery-low',
    'Opakované bakteriálne a kvasinkové vaginózy': 'flower-lotus', 'Osteoporóza a osteopénia': 'bone', 'PMS, bolesti pri menštruácií alebo ovulácií': 'calendar-heart', 'Endometrióza': 'gender-female', 'Hormonálne výkyvy': 'wave-sine',
    'Vysoký cholesterol': 'chart-line-up', 'Srdcovocievne zdravie': 'heartbeat', 'Ateroskleróza': 'pulse', 'Metabolický syndróm': 'gauge', 'Diabetes 2 typu': 'drop', 'Inzulínová rezistencia': 'chart-line',
    'Poruchy pečene': 'first-aid', 'Tukový metabolizmus': 'flask',
    'Chcem sa starať o svoj mikrobióm — zdravie čriev': 'plant', 'Chcem znížiť pravdepodobnosť vzniku chronických ochorení': 'heartbeat', 'Chcem mať viac energie': 'lightning',
    'Chcem mať lepšiu imunitu': 'shield-plus', 'Zlepšenie imunity': 'shield-plus', 'Zlepšenie metabolizmu / výkonu': 'barbell', 'Regenerácia': 'moon-stars',
    'Áno, často': 'cell-signal-full', 'Áno, zriedkavo': 'cell-signal-low', 'Nie': 'x-circle', 'Áno': 'check-circle', 'Pravidelne': 'repeat', 'Občas': 'clock-countdown',
    'Remisia': 'sun-horizon', 'Relaps': 'cloud-lightning', 'Krátkodobá intervencia': 'timer', 'Dlhodobo': 'infinity'
  };
  var QICON = {
    'Ako vám môžeme pomôcť?': 'compass', 'Čo vás najviac trápi?': 'target', 'Na čom by ste chceli zapracovať?': 'trend-up', 'Máte popri kožných problémoch aj problémy s trávením?': 'hand-heart',
    'Máte popri alergiách aj problémy s trávením?': 'flower-tulip', 'Ako často mávate zápchy?': 'calendar-dots', 'Koľko porcií ovocia a zeleniny prijímate denne?': 'bowl-food',
    'Užívate antibiotiká?': 'pill', 'Užívate antibiotiká na tento problém?': 'pill', 'Aká je fáza vášho ochorenia?': 'chart-line', 'Ako sa chcete starať o svoj mikrobióm?': 'plant',
    'Máte chronické ochorenia?': 'heartbeat', 'Cítite, že po jedle máte menej energie?': 'battery-medium', 'Máte problémy s trávením?': 'waves',
    'Máte poruchy trávenia - hnačka, zápcha, nafukovanie, bolesti?': 'waves'
  };
  var PORTIONS = { 'Denne zjem viac ako 5 porcií': ['5+', 6, '#3fae5a'], 'Denne zjem 2 až 5 porcií': ['2–5', 3, '#e0a42a'], 'Denne zjem 1 alebo žiadnu porciu': ['0–1', 1, '#d0573a'] };
  var PRODUCE = ['carrot', 'orange-slice', 'pepper', 'avocado', 'leaf', 'plant'];
  var MOOD_ACC = ['#d12d4f', '#c43a5c', '#8c5aa8', '#6b78a6', '#7f93a8', '#2fa39d', '#17a19e', '#22b38d', '#f2a93b', '#ffb341'];

  function goalAccent() {
    var g = state.path[0], c = state.path[1];
    for (var i = 0; i < GROUPS.length; i++) if (c && GROUPS[i][2].indexOf(c) !== -1) return GROUPS[i][1];
    return (GOALS[g] && GOALS[g][2]) || '#17a19e';
  }

  /* ------------------------------------------------------------ helpers */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function track(name, step) { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, quiz_version: 'martin_20260930_v2', step_number: step }); }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function hex(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function rgb(c, a) { return 'rgba(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ',' + (a == null ? 1 : a) + ')'; }
  function ramp(stops, v) { var x = clamp(v, 1, 10) - 1, i = Math.min(8, Math.floor(x)), t = x - i; return mix(hex(stops[i]), hex(stops[i + 1]), t); }
  function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }
  var PRODUCT_NAMES = {"hit-na-traveni": "HIT na Trávení+®", "imunobiom": "iMunobiom+®", "allergic": "ALLERGIC+®", "ladybiom": "LADYbiom+®", "cardiobiom": "CARDIObiom+®", "vitalbiom": "VITALbiom+®", "sportbiom": "SPORTbiom+®", "omega-3": "OMEGA-3+®", "mikrobiom": "Mikrobióm+®", "powerbiom": "POWERbiom+®", "iprobio-2-0": "iProbio 2.0®", "iplan-komplexny-servis-vasho-crevneho-mikrobiomu": "iPlan"};
  function nameOf(h) { return (P[h] && P[h].title) || PRODUCT_NAMES[h] || "Produkt iProbio"; }
  function canBuy(p) { return !!(p && p.available === true && /^\d+$/.test(String(p.variantId || "")) && Number(p.variantId) > 0 && Number.isFinite(Number(p.cents)) && Number(p.cents) > 0 && typeof p.price === "string" && p.price.trim()); }
  function splitLabel(l) { var i = l.indexOf(' — '); return i > 0 ? [l.slice(0, i), l.slice(i + 3)] : [l, '']; }
  function totalSteps() { return 3 + (state.profileStep >= 3 ? estTree() : 4); }
  function estTree() { try { var q = tree.question(state.profile, state.path); return q ? q.total - 3 : state.path.length; } catch (e) { return 4; } }

  function setTheme(t) { quiz.setAttribute('data-theme', t); }
  function show(id, pct, theme, wide) {
    clearTimeout(timer);
    anaTimers.forEach(clearTimeout); anaTimers = []; cancelAnimationFrame(anaRaf);
    if (figsCur) { figsCur.stop(); figsCur = null; }
    if (id !== 'loading' && ana) ana.stop();
    screens.forEach(function (s) { el[s].hidden = s !== id; });
    el[id].classList.remove('ipq-screen'); void el[id].offsetWidth; el[id].classList.add('ipq-screen');
    main.classList.toggle('ipq-intro-on', id === 'intro');
    main.classList.toggle('ipq-wide', !!wide);
    setTheme(theme || 'light');
    if (theme !== 'sky' && sky) sky.stop();
    progress.style.width = pct + '%';
    progress.setAttribute('aria-valuenow', Math.round(pct));
    state.stage = id;
    save();
    var heading = el[id].querySelector('h2');
    if (heading) { heading.setAttribute('tabindex', '-1'); try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); } }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
  function navrow(step, total) {
    return '<div class="ipq-navrow"><button type="button" class="ipq-back" id="ipq-back"><i class="ph ph-arrow-left" aria-hidden="true"></i> Zpět</button>' +
      '<span class="ipq-stepnum">Otázka ' + step + ' z ' + total + '</span></div>';
  }
  function wireBack() { var b = el.screen.querySelector('#ipq-back'); if (b) b.addEventListener('click', back); }
  function pickThen(btn, wrap, fn, delay) {
    if (wrap.classList.contains('is-chosen')) return;
    wrap.classList.add('is-chosen'); btn.classList.add('is-picked');
    setTimeout(fn, REDUCE ? 0 : (delay || 300));
  }

  /* ------------------------------------------------------------ flow */
  function start() {
    clearTimeout(timer);
    state = fresh('screen');
    track('quiz_start');
    renderProfile();
  }
  function renderProfile() {
    var n = state.profileStep;
    if (n === 0) renderSex(); else if (n === 1) renderFeel(); else renderAge();
  }
  function advanceProfile(stepNo) {
    state.profileStep++;
    track('quiz_step', stepNo);
    if (state.profileStep < 3) renderProfile(); else renderQuestion();
  }

  /* --- 1 · sex (coded particle figures) ----------------------- */
  function renderSex() {
    var U = COPY.ui || {};
    function card(v, label, icon) {
      return '<button type="button" class="ipq-gcard" data-value="' + v + '" aria-label="' + label + '">' +
        '<canvas class="ipq-gcard-cv" aria-hidden="true"></canvas>' +
        '<span class="ipq-gcard-label"><span class="ipq-gcard-ic"><i class="ph ph-' + icon + '" aria-hidden="true"></i></span><span class="ipq-gcard-name">' + label + '</span>' +
        '<span class="ipq-gcard-go"><i class="ph ph-arrow-right" aria-hidden="true"></i></span></span></button>';
    }
    el.screen.innerHTML = '<div class="ipq-head ipq-center"><span class="ipq-eyebrow"><i class="ph ph-user" aria-hidden="true"></i> Začínáme</span>' +
      '<h2 class="ipq-h">' + esc(U.sex_t || 'Vaše pohlaví') + '</h2><p class="ipq-sub">' + esc(U.sex_sub || '') + '</p></div>' +
      '<div class="ipq-gender">' + card('male', 'Muž', 'gender-male') + card('female', 'Žena', 'gender-female') + '</div>' +
      navrow(1, totalSteps());
    show('screen', 4, 'dark', true);
    var wrap = el.screen.querySelector('.ipq-gender');
    var figs = figsCur = Figures(Array.prototype.map.call(wrap.querySelectorAll('.ipq-gcard'), function (c) { return { card: c, kind: c.getAttribute('data-value') }; }));
    wrap.querySelectorAll('.ipq-gcard').forEach(function (c, idx) {
      if (!REDUCE) {
        c.addEventListener('pointermove', function (e) {
          var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          c.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
          figs.pointer(idx, e.clientX - r.left, e.clientY - r.top);
        });
        c.addEventListener('pointerleave', function () { c.style.removeProperty('--rx'); c.style.removeProperty('--ry'); figs.pointer(idx, null); });
      }
      c.addEventListener('pointerenter', function () { figs.hover(idx, true); });
      c.addEventListener('pointerleave', function () { figs.hover(idx, false); });
      c.addEventListener('focus', function () { figs.hover(idx, true); });
      c.addEventListener('blur', function () { figs.hover(idx, false); });
      c.addEventListener('click', function () {
        figs.burst(idx);
        pickThen(c, wrap, function () {
          figs.stop();
          var v = c.getAttribute('data-value');
          if (state.profile.sex !== v) state.path = [];
          state.profile.sex = v;
          advanceProfile(1);
        }, 750);
      });
    });
    wireBack();
    if (sky == null) sky = Sky(); // warm the sky sprites while the user decides
  }

  /* ============================================================ FIGURES (coded gender art) */
  // Silhouettes are drawn in a 300×400 design space, sampled into particles, then animated:
  // a hologram rim, drifting "cells", a spiral gut galaxy, pointer repulsion and a burst on pick.
  function mirror(g, pts) { // draw a closed path and its mirror around x = 150
    [1, -1].forEach(function (m) {
      g.beginPath(); g.moveTo(150 + m * (pts[0][0] - 150), pts[0][1]);
      for (var i = 1; i < pts.length; i++) {
        var q = pts[i];
        if (q.length === 6) g.bezierCurveTo(150 + m * (q[0] - 150), q[1], 150 + m * (q[2] - 150), q[3], 150 + m * (q[4] - 150), q[5]);
        else g.lineTo(150 + m * (q[0] - 150), q[1]);
      }
      g.closePath(); g.fill();
    });
  }
  var SIL = {
    male: function (g) {
      g.beginPath(); g.ellipse(150, 76, 29, 37, 0, 0, 6.2832); g.fill();
      g.beginPath(); g.moveTo(138, 100); g.lineTo(162, 100); g.lineTo(167, 140); g.lineTo(133, 140); g.closePath(); g.fill();
      g.beginPath(); g.moveTo(134, 130); g.bezierCurveTo(118, 140, 98, 144, 84, 156); g.bezierCurveTo(80, 190, 86, 240, 96, 290);
      g.bezierCurveTo(100, 330, 98, 370, 96, 400); g.lineTo(204, 400); g.bezierCurveTo(202, 370, 200, 330, 204, 290);
      g.bezierCurveTo(214, 240, 220, 190, 216, 156); g.bezierCurveTo(202, 144, 182, 140, 166, 130); g.closePath(); g.fill();
      mirror(g, [[86, 150], [62, 154, 48, 176, 48, 206], [48, 250, 52, 300, 54, 340], [56, 400], [76, 400], [78, 350, 78, 300, 80, 252], [82, 222, 84, 190, 89, 168]]);
    },
    female: function (g) {
      g.beginPath(); g.ellipse(150, 82, 27, 35, 0, 0, 6.2832); g.fill();
      g.beginPath(); g.moveTo(140, 108); g.lineTo(160, 108); g.lineTo(164, 144); g.lineTo(136, 144); g.closePath(); g.fill();
      g.beginPath(); g.moveTo(138, 134); g.bezierCurveTo(126, 142, 110, 146, 100, 156); g.bezierCurveTo(96, 186, 100, 214, 108, 236);
      g.bezierCurveTo(114, 254, 112, 270, 106, 292); g.bezierCurveTo(98, 320, 96, 360, 100, 400); g.lineTo(200, 400);
      g.bezierCurveTo(204, 360, 202, 320, 194, 292); g.bezierCurveTo(188, 270, 186, 254, 192, 236); g.bezierCurveTo(200, 214, 204, 186, 200, 156);
      g.bezierCurveTo(190, 146, 174, 142, 162, 134); g.closePath(); g.fill();
      mirror(g, [[101, 154], [82, 158, 72, 178, 72, 204], [72, 244, 76, 284, 78, 324], [80, 390], [96, 390], [96, 336, 96, 292, 98, 252], [100, 222, 102, 192, 106, 168]]);
    },
    hair: function (g) {
      g.beginPath(); g.moveTo(150, 40); g.bezierCurveTo(112, 38, 104, 82, 110, 120); g.bezierCurveTo(112, 152, 102, 180, 98, 210);
      g.bezierCurveTo(112, 214, 124, 200, 128, 180); g.bezierCurveTo(130, 152, 128, 130, 132, 114); g.lineTo(168, 114);
      g.bezierCurveTo(172, 130, 170, 152, 172, 180); g.bezierCurveTo(176, 200, 188, 214, 202, 210); g.bezierCurveTo(198, 180, 188, 152, 190, 120);
      g.bezierCurveTo(196, 82, 188, 38, 150, 40); g.closePath(); g.fill();
    }
  };
  var FIGPAL = {
    male: { rim: [143, 246, 238], body: [62, 214, 204], deep: [23, 161, 158], gal: [[226, 255, 252], [122, 240, 228], [255, 233, 168]], core: '122,240,228', bg: ['#0b2a3a', '#03111a'] },
    female: { rim: [176, 246, 248], body: [96, 214, 222], deep: [40, 150, 170], hair: [255, 168, 205], gal: [[255, 222, 236], [255, 143, 191], [255, 233, 168]], core: '255,143,191', bg: ['#1a2440', '#060f1c'] }
  };
  function samplePoints(kind) {
    var c = document.createElement('canvas'); c.width = 300; c.height = 400;
    var g = c.getContext('2d'); g.fillStyle = '#fff'; SIL[kind](g);
    var body = g.getImageData(0, 0, 300, 400).data, hair = null;
    if (kind === 'female') { g.clearRect(0, 0, 300, 400); SIL.hair(g); hair = g.getImageData(0, 0, 300, 400).data; }
    function inBody(x, y) { x |= 0; y |= 0; return x >= 0 && y >= 0 && x < 300 && y < 400 && body[(y * 300 + x) * 4 + 3] > 120; }
    function inHair(x, y) { x |= 0; y |= 0; return hair && x >= 0 && y >= 0 && x < 300 && y < 400 && hair[(y * 300 + x) * 4 + 3] > 120; }
    var pts = [], tries = 0, want = window.innerWidth < 600 ? 1000 : 1500;
    while (pts.length < want && tries < 90000) {
      tries++;
      var x = Math.random() * 300, y = 20 + Math.random() * 380, b = inBody(x, y), h = !b && inHair(x, y);
      if (!b && !h) continue;
      var edge = h ? false : (!inBody(x + 4, y) || !inBody(x - 4, y) || !inBody(x, y - 4) || !inBody(x, y + 4));
      if (!edge && !h && Math.random() > 0.42) continue;
      if (h && Math.random() > 0.55) continue;
      pts.push({ hx: x, hy: y, edge: edge, hair: h });
    }
    return pts;
  }
  var DOTS = {};
  function dot(c) { // soft round glow sprite, cached per colour
    var k = c.join(',');
    if (DOTS[k]) return DOTS[k];
    var cv = document.createElement('canvas'); cv.width = cv.height = 32;
    var g = cv.getContext('2d'), rg = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    rg.addColorStop(0, 'rgba(255,255,255,1)'); rg.addColorStop(0.18, 'rgba(' + k + ',1)'); rg.addColorStop(0.45, 'rgba(' + k + ',.35)'); rg.addColorStop(1, 'rgba(' + k + ',0)');
    g.fillStyle = rg; g.fillRect(0, 0, 32, 32);
    return (DOTS[k] = cv);
  }
  /* Gut shape the belly particles rest in (design units around the gut centre): the large-intestine
     frame (ascending → transverse → descending → sigmoid) and the small-intestine loops inside it.
     Each path is splined once and resampled to equal arc length, so a particle's position is an O(1) lookup. */
  function catmull(pts, n) {
    var out = [];
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
      for (var j = 0; j < n; j++) {
        var t = j / n, t2 = t * t, t3 = t2 * t;
        out.push([0.5 * (2 * p1[0] + (p2[0] - p0[0]) * t + (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 + (3 * p1[0] - p0[0] - 3 * p2[0] + p3[0]) * t3),
                  0.5 * (2 * p1[1] + (p2[1] - p0[1]) * t + (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 + (3 * p1[1] - p0[1] - 3 * p2[1] + p3[1]) * t3)]);
      }
    }
    out.push(pts[pts.length - 1]);
    return out;
  }
  function resample(poly, m) {
    var L = [0], i;
    for (i = 1; i < poly.length; i++) L.push(L[i - 1] + Math.hypot(poly[i][0] - poly[i - 1][0], poly[i][1] - poly[i - 1][1]));
    var tot = L[L.length - 1], out = [], k = 1;
    for (i = 0; i < m; i++) {
      var d = tot * i / (m - 1);
      while (k < L.length - 1 && L[k] < d) k++;
      var a = poly[k - 1], b = poly[k], f = (d - L[k - 1]) / ((L[k] - L[k - 1]) || 1);
      var tx = b[0] - a[0], ty = b[1] - a[1], tl = Math.hypot(tx, ty) || 1;
      out.push([a[0] + tx * f, a[1] + ty * f, -ty / tl, tx / tl]);
    }
    return out;
  }
  var GUT = (function () {
    var colon = [[-24, 34], [-33, 24], [-37, 4], [-37, -18], [-30, -31], [-15, -31], [0, -27], [15, -31], [30, -31], [37, -18], [37, 4], [34, 22], [24, 32], [12, 36], [3, 33], [0, 43]];
    // small intestine: a serpentine of five rows that alternates sides, ending at the junction with the colon (bottom left)
    var small = [], rows = [-18, -9, 0, 9, 18];
    rows.forEach(function (y, r) {
      var dir = r % 2 ? -1 : 1, xs = dir > 0 ? [-21, -11, 0, 11, 21] : [21, 11, 0, -11, -21];
      xs.forEach(function (x, j) { small.push([x, y + (j === 1 ? -3 : j === 3 ? 3 : 0)]); });
      small.push([25 * dir, y + 4.5]);
    });
    small.push([21, 27], [11, 29], [0, 26], [-11, 29], [-20, 31], [-24, 33]);
    return [resample(catmull(colon, 12), 420), resample(catmull(small, 10), 520)];
  })();
  function Figures(list) {
    var raf = 0, on = true, t0 = performance.now(), last = t0;
    var figs = list.map(function (f) {
      var cv = f.card.querySelector('canvas'), ctx = cv.getContext('2d'), pal = FIGPAL[f.kind];
      var pts = samplePoints(f.kind).map(function (p) {
        return { hx: p.hx, hy: p.hy, x: p.hx + (Math.random() - 0.5) * 220, y: p.hy + 160 + Math.random() * 120, vx: 0, vy: 0, ph: Math.random() * 6.28,
          r: p.edge ? 0.9 + Math.random() * 1.1 : 0.55 + Math.random() * 0.9, edge: p.edge, hair: p.hair, a: p.edge ? 0.85 : 0.38 + Math.random() * 0.3 };
      });
      var gal = [];
      for (var i = 0; i < 300; i++) {
        var arm = i % 3, rr = Math.pow(Math.random(), 0.6) * 40;
        var ip = i % 20 < 9 ? 0 : 1; // ~45 % large intestine (thicker tube), ~55 % small-intestine loops
        gal.push({ r: rr, th: arm * 2.094 + rr * 0.11 + (Math.random() - 0.5) * 0.5, s: 0.4 + Math.random() * 1.2, c: pal.gal[i % 3], z: Math.random(),
          ip: ip, u: Math.random(), off: (Math.random() - 0.5) * (ip ? 3.6 : 8), du: (ip ? 0.022 : 0.012) * (0.7 + Math.random() * 0.6) });
      }
      var bok = [];
      for (i = 0; i < 9; i++) bok.push({ x: Math.random(), y: Math.random(), r: 6 + Math.random() * 22, v: 0.004 + Math.random() * 0.01, ph: Math.random() * 6.28 });
      return { card: f.card, kind: f.kind, cv: cv, ctx: ctx, pal: pal, pts: pts, gal: gal, bok: bok, hov: 0, hovT: 0, mo: 0, mx: null, my: null, burst: 0, W: 0, H: 0 };
    });
    function size() {
      figs.forEach(function (f) {
        var r = f.cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 1.75);
        f.W = r.width; f.H = r.height; f.cv.width = Math.round(r.width * d); f.cv.height = Math.round(r.height * d); f.ctx.setTransform(d, 0, 0, d, 0, 0);
      });
    }
    function draw(f, t, dt) {
      var ctx = f.ctx, W = f.W, H = f.H, pal = f.pal;
      if (!W) return;
      f.hov += (f.hovT - f.hov) * Math.min(1, dt * 6);
      var s = Math.min(W / 300, H / 400) * 1.02, ox = (W - 300 * s) / 2, oy = H - 400 * s + H * 0.02;
      var bg = ctx.createRadialGradient(W / 2, H * 0.55, 0, W / 2, H * 0.55, Math.max(W, H) * 0.75);
      bg.addColorStop(0, pal.bg[0]); bg.addColorStop(1, pal.bg[1]); ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
      // floating capsules (bokeh)
      f.bok.forEach(function (b) {
        if (!REDUCE) { b.y -= b.v * dt * 6; if (b.y < -0.1) { b.y = 1.1; b.x = Math.random(); } }
        var bx = b.x * W + Math.sin(t * 0.4 + b.ph) * 10, by = b.y * H;
        ctx.strokeStyle = 'rgba(' + pal.rim.join(',') + ',' + (0.1 + 0.06 * f.hov) + ')'; ctx.lineWidth = 1;
        ctx.fillStyle = 'rgba(' + pal.body.join(',') + ',.04)'; ctx.beginPath(); ctx.arc(bx, by, b.r, 0, 6.283); ctx.fill(); ctx.stroke();
      });
      ctx.globalCompositeOperation = 'lighter';
      // aura behind the figure
      var gx = ox + 150 * s, gy = oy + (f.kind === 'female' ? 262 : 270) * s;
      var aura = ctx.createRadialGradient(gx, oy + 230 * s, 0, gx, oy + 230 * s, 220 * s);
      aura.addColorStop(0, 'rgba(' + pal.deep.join(',') + ',' + (0.16 + 0.12 * f.hov) + ')'); aura.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = aura; ctx.fillRect(0, 0, W, H);
      // body particles
      var k = 1 - Math.pow(0.02, dt), mxr = 46 * s;
      for (var i = 0; i < f.pts.length; i++) {
        var p = f.pts[i];
        var tx = ox + (p.hx + Math.sin(t * 0.9 + p.ph) * 1.6 + (p.hair ? Math.sin(t * 0.7 + p.hy * 0.04) * 4 : 0)) * s;
        var ty = oy + (p.hy + Math.cos(t * 0.8 + p.ph) * 1.6) * s;
        if (f.burst > 0) { var dx0 = p.x - gx, dy0 = p.y - gy, dd = Math.sqrt(dx0 * dx0 + dy0 * dy0) || 1; p.vx += dx0 / dd * 900 * dt * f.burst; p.vy += dy0 / dd * 900 * dt * f.burst; }
        else if (!REDUCE) { p.vx += (tx - p.x) * 9 * dt; p.vy += (ty - p.y) * 9 * dt; }
        else { p.x = tx; p.y = ty; }
        if (f.mx != null) { var dx = p.x - f.mx, dy = p.y - f.my, d2 = dx * dx + dy * dy; if (d2 < mxr * mxr) { var dd2 = Math.sqrt(d2) || 1, fo = (1 - dd2 / mxr) * 520 * dt; p.vx += dx / dd2 * fo; p.vy += dy / dd2 * fo; } }
        p.vx *= 1 - k * 0.9; p.vy *= 1 - k * 0.9; p.x += p.vx * dt * 6; p.y += p.vy * dt * 6;
        var tw = 0.75 + 0.25 * Math.sin(t * 2.2 + p.ph * 3), col = p.hair ? pal.hair : (p.edge ? pal.rim : pal.body);
        var a = p.a * tw * (0.85 + 0.35 * f.hov) * (f.burst > 0 ? Math.max(0, 1 - f.burst * 0.6) : 1);
        var rr = p.r * s * (1.9 + 0.4 * f.hov);
        ctx.globalAlpha = Math.min(1, a); ctx.drawImage(dot(col), p.x - rr, p.y - rr, rr * 2, rr * 2);
      }
      // gut: intestine shape at rest, unwinds into the galaxy on hover/focus (staggered per particle)
      f.mo += ((f.hovT ? 1 : 0) - f.mo) * (REDUCE ? 1 : Math.min(1, dt * 2.6));
      var mo = f.mo, gs = s * (f.kind === 'female' ? 1.0 : 1.12);
      var cr = 62 * s * (0.6 + 0.4 * mo) * (1 + 0.15 * f.hov);
      var core = ctx.createRadialGradient(gx, gy, 0, gx, gy, cr);
      core.addColorStop(0, 'rgba(255,255,255,' + (0.3 + 0.5 * mo) + ')'); core.addColorStop(0.25, 'rgba(' + pal.core + ',' + (0.24 + 0.34 * mo) + ')'); core.addColorStop(1, 'rgba(' + pal.core + ',0)');
      ctx.fillStyle = core; ctx.beginPath(); ctx.arc(gx, gy, cr, 0, 6.283); ctx.fill();
      var spin = (REDUCE ? 0 : t) * (0.5 + 0.9 * f.hov);
      for (i = 0; i < f.gal.length; i++) {
        var q = f.gal[i];
        if (!REDUCE) { q.u += q.du * dt * (1 - 0.7 * mo); if (q.u >= 1) q.u -= 1; }
        var path = GUT[q.ip], sp = path[Math.min(path.length - 1, (q.u * (path.length - 1)) | 0)];
        var wob = Math.sin(t * 2.1 + q.z * 9) * 0.6;
        var ix = gx + (sp[0] + sp[2] * (q.off + wob)) * gs, iy = gy + (sp[1] + sp[3] * (q.off + wob)) * gs;
        var th = q.th + spin * (1.2 - q.r / 60), rad = q.r * s * (1 + 0.1 * Math.sin(t * 1.5 + q.z * 6));
        var ax = gx + Math.cos(th) * rad, ay = gy + Math.sin(th) * rad * 0.62;
        var k2 = clamp(mo * 1.35 - q.z * 0.35, 0, 1), e = k2 * k2 * (3 - 2 * k2);
        var bx = 1 + f.burst * 3, px = gx + ((ix + (ax - ix) * e) - gx) * bx, py = gy + ((iy + (ay - iy) * e) - gy) * bx;
        ctx.globalAlpha = (0.5 + q.z * 0.5) * (1 - Math.min(1, f.burst));
        var gr = (0.8 + q.s) * s * (1.45 + 0.15 * e); ctx.drawImage(dot(q.c), px - gr, py - gr, gr * 2, gr * 2);
      }
      ctx.globalAlpha = 1;
      if (f.burst > 0) f.burst = Math.min(1.6, f.burst + dt * 2.2);
    }
    function frame(now) {
      if (!on) return;
      var t = (now - t0) / 1000, dt = Math.min(0.05, (now - last) / 1000 || 0.016); last = now;
      figs.forEach(function (f) { draw(f, t, dt); });
      if (!REDUCE) raf = requestAnimationFrame(frame);
    }
    size();
    var onResize = function () { size(); if (REDUCE) frame(performance.now()); };
    window.addEventListener('resize', onResize);
    if (REDUCE) figs.forEach(function (f) { f.pts.forEach(function (p) { p.x = p.hx; p.y = p.hy; }); });
    raf = requestAnimationFrame(frame);
    return {
      pointer: function (i, x, y) { figs[i].mx = x; figs[i].my = y; },
      hover: function (i, onOff) { figs[i].hovT = onOff ? 1 : 0; if (REDUCE) frame(performance.now()); },
      burst: function (i) { figs[i].burst = 0.01; figs[i].hovT = 1; },
      stop: function () { on = false; cancelAnimationFrame(raf); window.removeEventListener('resize', onResize); }
    };
  }

  /* --- 2 · feeling (coded sky + orb) -------------------------- */
  function renderFeel() {
    var U = COPY.ui || {};
    var v0 = Number(state.profile.health) || 5;
    var ticks = '';
    for (var i = 1; i <= 10; i++) ticks += '<button type="button" data-v="' + i + '" aria-label="' + i + ' z 10" aria-describedby="ipq-readout">' + i + '</button>';
    el.screen.innerHTML = '<div class="ipq-feel">' +
      '<div class="ipq-head ipq-center" style="margin-bottom:.4rem"><span class="ipq-eyebrow"><i class="ph ph-cloud-sun" aria-hidden="true"></i> Váš pocit</span>' +
      '<h2 class="ipq-h">' + esc(U.health_t || 'Ohodnoťte kvalitu svého zdraví') + '</h2><p class="ipq-sub">' + esc(U.health_sub || '') + '</p></div>' +
      '<div class="ipq-orb-wrap" aria-hidden="true">' + ORB_SVG + '</div>' +
      '<div class="ipq-readout" id="ipq-readout"><span class="ipq-readout-n"><span id="ipq-feel-n">5</span><small>/10</small></span>' +
      '<span class="ipq-readout-t" id="ipq-feel-t"></span><span class="ipq-readout-s" id="ipq-feel-s"></span></div>' +
      '<div class="ipq-slider"><label class="ipq-sr" for="ipq-feel">Jak se celkově cítíte, od 1 do 10</label>' +
      '<input class="ipq-range' + (state.profile.health ? '' : ' is-idle') + '" id="ipq-feel" type="range" min="1" max="10" step="0.01" value="' + v0 + '">' +
      '<div class="ipq-ticks">' + ticks + '</div>' +
      '<div class="ipq-ends"><span><i class="ph ph-cloud-lightning" aria-hidden="true"></i> Velmi špatně</span><span>Výborně <i class="ph ph-sun" aria-hidden="true"></i></span></div></div>' +
      '<button type="button" class="ipq-btn ipq-btn-primary" id="ipq-feel-go">Pokračovat <i class="ph ph-arrow-right" aria-hidden="true"></i></button>' +
      navrow(2, totalSteps()) + '</div>';
    show('screen', 12, 'sky', false);
    var input = el.screen.querySelector('#ipq-feel'), readout = el.screen.querySelector('#ipq-readout');
    var nEl = el.screen.querySelector('#ipq-feel-n'), tEl = el.screen.querySelector('#ipq-feel-t'), sEl = el.screen.querySelector('#ipq-feel-s');
    var tickBtns = el.screen.querySelectorAll('.ipq-ticks button');
    var lastInt = 0;
    if (!sky) sky = Sky();
    sky.start(el.screen.querySelector('.ipq-orb'), v0);
    function label(v) {
      var n = Math.round(v), m = (COPY.moods || [])[n - 1] || { t: '', s: '' };
      input.setAttribute('aria-valuetext', n + ' z 10, ' + m.t);
      if (n !== lastInt) {
        lastInt = n;
        nEl.textContent = n;
        tickBtns.forEach(function (b) { b.classList.toggle('on', Number(b.getAttribute('data-v')) === n); });
        readout.classList.add('is-swap');
        setTimeout(function () { tEl.textContent = m.t; sEl.textContent = m.s; readout.classList.remove('is-swap'); }, REDUCE ? 0 : 120);
      }
    }
    function set(v, snap) {
      v = clamp(v, 1, 10);
      if (snap) { v = Math.round(v); input.value = v; }
      sky.target(v);
      label(v);
    }
    set(v0, true);
    input.addEventListener('input', function () { input.classList.remove('is-idle'); set(Number(input.value)); });
    input.addEventListener('change', function () { set(Number(input.value), true); });
    input.addEventListener('pointerup', function () { set(Number(input.value), true); });
    input.addEventListener('keydown', function (e) {
      var k = e.key, cur = Math.round(Number(input.value));
      if (k === 'ArrowRight' || k === 'ArrowUp') { e.preventDefault(); set(cur + 1, true); }
      else if (k === 'ArrowLeft' || k === 'ArrowDown') { e.preventDefault(); set(cur - 1, true); }
      else if (k === 'Home') { e.preventDefault(); set(1, true); } else if (k === 'End') { e.preventDefault(); set(10, true); }
      else if (k === 'Enter') { e.preventDefault(); go(); }
      input.classList.remove('is-idle');
    });
    tickBtns.forEach(function (b) { b.addEventListener('click', function () { input.classList.remove('is-idle'); set(Number(b.getAttribute('data-v')), true); }); });
    function go() {
      state.profile.health = Math.round(Number(input.value));
      advanceProfile(2);
    }
    el.screen.querySelector('#ipq-feel-go').addEventListener('click', go);
    wireBack();
  }

  /* --- 3 · age ------------------------------------------------- */
  function renderAge() {
    var U = COPY.ui || {};
    var age = state.profile.age || '';
    el.screen.innerHTML = '<div class="ipq-head ipq-center"><div class="ipq-pict" aria-hidden="true"><i class="ph-duotone ph-tree"></i></div>' +
      '<h2 class="ipq-h">' + esc(U.age_t || 'Kolik je vám let?') + '</h2><p class="ipq-sub">' + esc(U.age_sub || '') + '</p></div>' +
      '<form class="ipq-age" id="ipq-age-form" novalidate>' +
      '<div class="ipq-age-dial"><button type="button" class="ipq-age-step" data-d="-1" aria-label="Méně"><i class="ph ph-minus" aria-hidden="true"></i></button>' +
      '<label class="ipq-age-val"><span class="ipq-sr">Věk v letech</span><input class="ipq-age-input" id="ipq-age" type="number" inputmode="numeric" min="1" max="99" step="1" placeholder="—" value="' + esc(age) + '"><span class="ipq-age-unit">let</span></label>' +
      '<button type="button" class="ipq-age-step" data-d="1" aria-label="Více"><i class="ph ph-plus" aria-hidden="true"></i></button></div>' +
      '<input class="ipq-ruler' + (age ? '' : ' is-unset') + '" id="ipq-age-r" type="range" min="1" max="99" step="1" value="' + (age || 40) + '" aria-label="Věk, posuvník">' +
      '<div class="ipq-ruler-scale" aria-hidden="true"><span>1</span><span>20</span><span>40</span><span>60</span><span>80</span><span>99</span></div>' +
      '<div id="ipq-age-note" aria-live="polite"></div>' +
      '<button class="ipq-btn ipq-btn-primary ipq-btn-block" type="submit" id="ipq-age-go"' + (age ? '' : ' disabled') + '>Pokračovat <i class="ph ph-arrow-right" aria-hidden="true"></i></button></form>' +
      navrow(3, totalSteps());
    quiz.style.setProperty('--acc', '#17a19e');
    show('screen', 20, 'light', false);
    var input = el.screen.querySelector('#ipq-age'), ruler = el.screen.querySelector('#ipq-age-r');
    var go = el.screen.querySelector('#ipq-age-go'), note = el.screen.querySelector('#ipq-age-note'), pict = el.screen.querySelector('.ipq-pict i');
    function sync(v, from) {
      v = Math.round(clamp(Number(v) || 0, 1, 99));
      if (from !== 'input') input.value = v;
      if (from !== 'ruler') ruler.value = v;
      ruler.classList.remove('is-unset');
      go.disabled = false;
      pict.className = 'ph-duotone ph-' + (v < 18 ? 'plant' : v <= 50 ? 'tree' : 'tree-evergreen');
      var over = v > 50;
      if (over && !note.firstChild) note.innerHTML = '<span class="ipq-age-note"><i class="ph ph-sparkle" aria-hidden="true"></i> ' + esc(U.age_50 || '') + '</span>';
      if (!over) note.innerHTML = '';
    }
    if (age) sync(age);
    ruler.addEventListener('input', function () { sync(ruler.value, 'ruler'); });
    input.addEventListener('input', function () { if (input.value !== '') sync(input.value, 'input'); else { go.disabled = true; } });
    el.screen.querySelectorAll('.ipq-age-step').forEach(function (b) {
      b.addEventListener('click', function () { var cur = Number(input.value) || 40; sync(cur + Number(b.getAttribute('data-d'))); });
    });
    el.screen.querySelector('#ipq-age-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = Number(input.value);
      if (!Number.isInteger(v) || v < 1 || v > 99) { input.focus(); return; }
      if (state.profile.age !== v) state.path = [];
      state.profile.age = v;
      advanceProfile(3);
    });
    wireBack();
  }

  /* --- 4+ · tree questions ------------------------------------ */
  function optBtn(o, i, cls, inner) {
    var lab = splitLabel(o.l);
    var ic = ICONS[o.v] || 'circle';
    var acc = '';
    GROUPS.forEach(function (g) { if (g[2].indexOf(o.v) !== -1) acc = g[1]; });
    if (GOALS[o.v]) { ic = GOALS[o.v][0]; acc = GOALS[o.v][2]; if (!lab[1]) lab[1] = uiLabel(GOALS[o.v][1]); }
    var yesno = /^Áno/.test(o.v) ? ' is-yes' : (o.v === 'Nie' ? ' is-no' : '');
    return '<button type="button" class="ipq-opt' + (cls || '') + yesno + '" data-value="' + esc(o.v) + '" style="--i:' + i + (acc ? ';--c:' + acc : '') + '">' +
      (inner || ('<span class="ipq-opt-ic"><i class="ph-duotone ph-' + ic + '" aria-hidden="true"></i></span>')) +
      '<span class="ipq-opt-tx"><span>' + esc(lab[0]) + '</span>' + (lab[1] ? '<span class="ipq-opt-h">' + esc(lab[1]) + '</span>' : '') + '</span>' +
      '<span class="ipq-opt-go"><i class="ph ph-arrow-right go-a" aria-hidden="true"></i><i class="ph-bold ph-check go-c" aria-hidden="true"></i></span></button>';
  }
  function renderQuestion() {
    var q = tree.question(state.profile, state.path);
    if (!q) { analyze(); return; }
    quiz.style.setProperty('--acc', goalAccent());
    var vals = q.options.map(function (o) { return o.v; });
    var body = '';
    if (q.t === 'Čo vás najviac trápi?') {
      GROUPS.forEach(function (g) {
        var items = q.options.filter(function (o) { return g[2].indexOf(o.v) !== -1; });
        if (!items.length) return;
        body += '<div class="ipq-group"><div class="ipq-group-h" style="--c:' + g[1] + '">' + esc(uiLabel(g[0])) + '</div><div class="ipq-opts">' +
          items.map(function (o, i) { return optBtn(o, i); }).join('') + '</div></div>';
      });
      var rest = q.options.filter(function (o) { return !GROUPS.some(function (g) { return g[2].indexOf(o.v) !== -1; }); });
      if (rest.length) body += '<div class="ipq-group"><div class="ipq-opts">' + rest.map(function (o, i) { return optBtn(o, i); }).join('') + '</div></div>';
      body = '<div class="ipq-groups">' + body + '</div>';
    } else if (q.t === PORTIONS_Q) {
      body = '<div class="ipq-opts ipq-row" style="--n:3">' + q.options.map(function (o, i) {
        var p = PORTIONS[o.v] || ['', 1, '#17a19e'], icons = '';
        for (var j = 0; j < 6; j++) icons += '<i class="ph-duotone ph-' + PRODUCE[j] + (j < p[1] ? '' : ' off') + '" style="--j:' + j + '" aria-hidden="true"></i>';
        return optBtn(o, i, ' ipq-tall ipq-center', '<span class="ipq-portion" style="--pc:' + p[2] + '">' + icons + '</span><span class="ipq-portion-n">' + p[0] + '</span>');
      }).join('') + '</div>';
    } else if (vals.every(function (v) { return GOALS[v]; })) {
      body = '<div class="ipq-opts ipq-grid2">' + q.options.map(function (o, i) { return optBtn(o, i, ' ipq-tall'); }).join('') + '</div>';
    } else if (q.options.length <= 3 && q.options.every(function (o) { return o.l.length < 34; })) {
      body = '<div class="ipq-opts ipq-row" style="--n:' + q.options.length + '">' + q.options.map(function (o, i) { return optBtn(o, i, ' ipq-tall ipq-center'); }).join('') + '</div>';
    } else {
      body = '<div class="ipq-opts' + (q.options.length > 3 ? ' ipq-grid2' : '') + '">' + q.options.map(function (o, i) { return optBtn(o, i); }).join('') + '</div>';
    }
    var sub = (COPY.subs || {})[q.t];
    var wide = q.t === 'Čo vás najviac trápi?' || vals.every(function (v) { return GOALS[v]; });
    el.screen.innerHTML = '<div class="ipq-head' + (wide ? '' : ' ipq-center') + '"><div class="ipq-pict" aria-hidden="true"><i class="ph-duotone ph-' + (QICON[q.t] || 'sparkle') + '"></i></div>' +
      '<h2 class="ipq-h">' + esc(questionLabel(q.t)) + '</h2>' + (sub ? '<p class="ipq-sub">' + esc(sub) + '</p>' : '') + '</div>' + body + navrow(q.step, q.total);
    show('screen', Math.min(92, 20 + (q.step - 3) / Math.max(1, q.total - 3) * 72), 'light', wide);
    el.screen.querySelectorAll('[data-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wrap = b.closest('.ipq-groups') || b.closest('.ipq-opts');
        pickThen(b, wrap, function () { state.path.push(b.getAttribute('data-value')); track('quiz_step', q.step); renderQuestion(); });
      });
    });
    wireBack();
  }
  function back() {
    if (state.profileStep < 3) {
      if (state.profileStep === 0) { show('intro', 0, 'dark'); quiz.querySelector('#ipq-start').focus(); return; }
      state.profileStep--;
      renderProfile();
    } else if (state.path.length) {
      state.path.pop();
      renderQuestion();
    } else {
      state.profileStep = 2;
      renderProfile();
    }
  }

  var ANA_MS = 7000;
  // short, natural labels for the "Vyhodnocujeme oblasť: …" analysis step
  var AREA = {
    'Chcem zlepšiť svoj životný štýl a zapracovať na dlhovekosti (prevencia)': 'životný štýl a dlhovekosť',
    'Chcem pracovať na svojom športovom výkone a metabolizme': 'šport a metabolizmus', 'Užívam ATB a chcem obmedziť ich vedľajšie účinky': 'antibiotiká',
    'Chcem zistiť, aké potraviny sú vhodné pre môj unikátny mikrobióm': 'strava na mieru', 'Mám viacero zdravotných problémov súčasne a chcem to najlepšie pre môj mikrobióm': 'viacero ťažkostí naraz',
    'Chcem zapracovať na prevencií chronických ochorení (srdcovocievne, metabolické, a pod.)': 'srdce a metabolizmus', 'Chcem mať viac energie.': 'energia',
    'Chcem sa starať o svoj mikrobióm — zdravie čriev': 'zdravie čriev', 'Chcem znížiť pravdepodobnosť vzniku chronických ochorení': 'dlhodobé zdravie',
    'Chcem mať viac energie': 'energia', 'Chcem mať lepšiu imunitu': 'imunita', 'Zlepšenie imunity': 'imunita', 'Zlepšenie metabolizmu / výkonu': 'metabolizmus a výkon', 'Regenerácia': 'regenerácia'
  };
  function low(t) { return /^[A-ZÁ-Ž]{2}/.test(t) ? t : t.charAt(0).toLowerCase() + t.slice(1); }
  function analyze() {
    var U = COPY.ui || {}, prof = state.profile, path = state.path;
    var area = '', portions = '';
    path.forEach(function (v) {
      if (PORTIONS[v]) portions = PORTIONS[v][0];
      else if (AREA[v]) area = uiLabel(AREA[v]);
      else if (!/^(Áno|Nie)/.test(v) && !GOALS[v]) area = low(splitLabel(answerLabel(v))[0]);
    });
    var fill = { mood: prof.health, age: prof.age, area: area, portions: portions };
    var steps = (U.analysis_steps || []).filter(function (s) {
      var ok = true; s.replace(/\{(\w+)\}/g, function (m, k) { if (!fill[k] && fill[k] !== 0) ok = false; return m; }); return ok;
    }).map(function (s) { return s.replace(/\{(\w+)\}/g, function (m, k) { return fill[k]; }); });
    var list = quiz.querySelector('#ipq-ana-steps');
    list.innerHTML = steps.map(function (s) {
      return '<li class="is-wait"><span class="ipq-ana-dot" aria-hidden="true"><i class="ph-bold ph-check"></i></span><span>' + esc(s) + '</span></li>';
    }).join('');
    var pctEl = quiz.querySelector('#ipq-ana-pct'), ring = quiz.querySelector('#ipq-ana-arc'), title = quiz.querySelector('#ipq-ana-title');
    title.textContent = U.analysis_t || 'Analyzujeme vaše odpovědi…';
    quiz.querySelector('#ipq-ana-wrap').classList.remove('is-done');
    show('loading', 92, 'dark');
    try { // warm the result images while the analysis runs
      var pre = tree.compute(state.profile, state.path);
      pre.primary.concat(pre.addons, pre.ageAddon).forEach(function (h) { if (P[h] && P[h].image) { var im = new Image(); im.src = P[h].image; } });
    } catch (e) {}
    ana = ana || Swirl(quiz.querySelector('#ipq-ana-cv'));
    ana.start(state.profile.sex === 'female');
    var items = list.querySelectorAll('li'), n = items.length, t0 = performance.now(), slot = (ANA_MS - 900) / Math.max(1, n);
    var C = 2 * Math.PI * 46;
    function tick(now) {
      if (state.stage !== 'loading') return;
      var t = Math.min(1, (now - t0) / ANA_MS), e = 1 - Math.pow(1 - t, 1.6);
      var pct = Math.round(e * 100);
      pctEl.textContent = pct + ' %';
      ring.style.strokeDashoffset = (C * (1 - e)).toFixed(1);
      progress.style.width = (92 + 6 * e) + '%';
      var el0 = now - t0 - 250;
      for (var i = 0; i < n; i++) {
        var st = el0 < i * slot ? 'is-wait' : (el0 < (i + 1) * slot ? 'is-run' : 'is-done');
        if (items[i].className !== st) items[i].className = st;
      }
      if (t < 1) anaRaf = requestAnimationFrame(tick);
    }
    cancelAnimationFrame(anaRaf); anaRaf = requestAnimationFrame(tick);
    anaTimers.push(setTimeout(function () {
      quiz.querySelector('#ipq-ana-wrap').classList.add('is-done');
      title.textContent = U.analysis_done || title.textContent;
    }, ANA_MS - 600));
    timer = setTimeout(showEmail, ANA_MS);
  }
  function showEmail() { if (ana) ana.stop(); show('email', 98, 'light'); track('quiz_email_shown'); }

  /* --- results -------------------------------------------------- */
  // whole explanation text, broken into short paragraphs (~2 sentences)
  function paras(t) {
    var parts = String(t || '').replace(/([.!?…])\s+(?=[„"A-ZÁÄČĎÉÍĹĽŇÓÔŔŠŤÚÝŽ]|i[A-Z])/g, '$1\u0001').split('\u0001'), out = [], cur = '';
    parts.forEach(function (x) { cur = cur ? cur + ' ' + x : x; if (cur.length > 240) { out.push(cur); cur = ''; } });
    if (cur) out.push(cur);
    return out.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('');
  }
  function card(h, kind, i, text) {
    var p = P[h];
    if (!p) return '<div class="ipq-toast-msg err">Produkt momentálně není dostupný. <a href="/pages/kontakt">Kontaktujte nás</a>.</div>';
    var tag = { main: '<i class="ph-fill ph-star" aria-hidden="true"></i> Hlavní doporučení', addon: 'Doplňkové doporučení', age: 'Zdravé stárnutí', alt: 'Alternativa' }[kind];
    var vt = p.variantTitle && p.variantTitle !== 'Default Title' ? '<small>' + esc(p.variantTitle) + '</small>' : '';
    var buy = canBuy(p)
      ? '<form action="/cart/add" method="post" class="ipq-add" data-id="' + esc(p.variantId) + '"><input type="hidden" name="id" value="' + esc(p.variantId) + '"><input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="ipq-btn ipq-btn-buy"><i class="ph ph-shopping-cart-simple" aria-hidden="true"></i> Do košíku</button></form>'
      : '<span class="ipq-card-line">Momentálně vyprodáno</span>';
    return '<article class="ipq-card ipq-card-' + kind + ' ipq-rv" style="--c:' + (ACCENT[h] || '#17a19e') + ';--d:' + (i % 4) + '" data-product="' + esc(h) + '">' +
      '<a class="ipq-card-art" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt=""' + (kind === 'main' ? ' fetchpriority="high"' : ' loading="lazy"') + '>' : '') + '</a>' +
      '<div class="ipq-card-body"><span class="ipq-tag">' + tag + '</span><h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      (text ? '<div class="ipq-card-why">' + paras(text) + '</div>' : '') +
      '<div class="ipq-card-buy"><span class="ipq-price">' + (canBuy(p) ? esc(p.price) + vt : '') + '</span>' + buy +
      '<a href="' + esc(p.url) + '" class="ipq-btn ipq-btn-ghost">Detail</a></div></div></article>';
  }
  function words(t) { return esc(t).split(' ').map(function (w, i) { return '<span class="ipq-w" style="--w:' + i + '">' + w + '</span>'; }).join(' '); }
  function renderResults() {
    var r = tree.compute(state.profile, state.path), U = COPY.ui || {};
    var rc = (COPY.rows || {})[r.row] || {};
    var titles = r.primary.map(nameOf), ci = 0, lastAns = state.path[state.path.length - 1];
    var chips = '<span style="--i:' + (ci++) + '"><i class="ph ph-gender-' + (state.profile.sex === 'female' ? 'female' : 'male') + '" aria-hidden="true"></i>' + (state.profile.sex === 'female' ? 'Žena' : 'Muž') + '</span>' +
      '<span style="--i:' + (ci++) + '"><i class="ph ph-cake" aria-hidden="true"></i>' + state.profile.age + ' let</span>' +
      '<span style="--i:' + (ci++) + '"><span class="ipq-dot" style="--d:' + MOOD_ACC[state.profile.health - 1] + '"></span>Pocit ' + state.profile.health + '/10</span>';
    state.path.forEach(function (v) {
      if (v === lastAns && PORTIONS[v]) chips += '<span style="--i:' + (ci++) + '"><i class="ph ph-bowl-food" aria-hidden="true"></i>' + PORTIONS[v][0] + ' porcí</span>';
      else if (!/^(Áno|Nie)/.test(v) && !PORTIONS[v]) chips += '<span style="--i:' + (ci++) + '"><i class="ph ph-' + ((GOALS[v] && GOALS[v][0]) || ICONS[v] || 'check') + '" aria-hidden="true"></i>' +
        esc(cap(splitLabel(answerLabel(v))[0].replace(/^Chci /, '').replace(/\s*\(.*\)\s*$/, '').replace(/\.$/, ''))) + '</span>';
    });
    var head = 'Pro vás jsme vybrali ' + (titles.length > 1 ? titles.slice(0, -1).join(', ') + ' a ' + titles[titles.length - 1] : titles[0]);
    var html = '<div class="ipq-res-head"><canvas class="ipq-bloom" id="ipq-bloom" aria-hidden="true"></canvas>' +
      '<span class="ipq-eyebrow"><i class="ph ph-seal-check" aria-hidden="true"></i> Vaše doporučení</span>' +
      '<h2 class="ipq-h" aria-label="' + esc(head) + '">' + words(head) + '</h2>' +
      '<div class="ipq-summary" aria-label="Vaše odpovědi">' + chips + '</div></div>';
    if (rc.t) html += '<section class="ipq-sit ipq-rv"><h3 class="ipq-sec-t"><span class="ipq-sec-ic"><i class="ph-duotone ph-info" aria-hidden="true"></i></span>' + esc(U.why_t || 'Proč právě tato sestava') + '</h3>' + paras(rc.t) + '</section>';
    var i = 0;
    html += '<section class="ipq-mains">' + r.primary.map(function (h) { return card(h, 'main', i++); }).join('') + '</section>';
    if (r.addons.length) html += '<section class="ipq-block"><h3 class="ipq-sec-t ipq-rv">Doplňkové produkty</h3><div class="ipq-grid">' + r.addons.map(function (h) { return card(h, 'addon', i++); }).join('') + '</div></section>';
    if (r.ageAddon.length) html += '<section class="ipq-block"><h3 class="ipq-sec-t ipq-rv">' + esc((COPY.age && COPY.age.title) || 'Zdravé stárnutí') + '</h3><div class="ipq-grid">' +
      r.ageAddon.map(function (h) { return card(h, 'age', i++, (COPY.age && COPY.age.t) || ''); }).join('') + '</div></section>';
    if (r.personalized) html += '<section class="ipq-block"><h3 class="ipq-sec-t ipq-rv">' + esc((COPY.personalized && COPY.personalized.title) || 'Personalizovaná alternativa') + '</h3><div class="ipq-grid">' +
      card('iprobio-2-0', 'alt', i++, ((COPY.personalized && COPY.personalized.t) || '').replace('{n}', state.profile.health)) + '</div></section>';
    html += '<p class="ipq-disclaimer">Doplňky stravy nenahrazují pestrou stravu ani lékařskou péči. Při zdravotních potížích, užívání léků, během těhotenství a kojení nebo při výběru pro dítě se poraďte s lékařem.</p>' +
      '<div class="ipq-support">Potřebujete poradit? <a href="/pages/kontakt">Napište nám</a>.</div>' +
      '<button type="button" class="ipq-restart" id="ipq-restart"><i class="ph ph-arrow-counter-clockwise" aria-hidden="true"></i> Začít znovu</button>';
    el.results.innerHTML = html;
    quiz.style.setProperty('--acc', ACCENT[r.primary[0]] || '#17a19e');
    if (state.stage !== 'results') track('quiz_complete');
    show('results', 100, 'light', true);
    el.results.dataset.sourceRow = r.row;
    track('quiz_result_view');
    resultsMotion(state.profile.sex === 'female');
    el.results.querySelector('#ipq-restart').addEventListener('click', function () { track('quiz_restart'); start(); });
    el.results.querySelectorAll('a.ipq-btn, .ipq-card h3 a').forEach(function (a) { a.addEventListener('click', function () { track('quiz_cta_click'); save(); }); });
    el.results.querySelectorAll('form.ipq-add').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault(); save(); track('quiz_add_to_cart');
        addToCart([f.getAttribute('data-id')], f.querySelector('button'), function () { f.submit(); });
      });
    });
  }
  // results motion: one-shot particle bloom behind the headline + scroll reveal
  var revealIO = null;
  function resultsMotion(female) {
    var items = el.results.querySelectorAll('.ipq-rv');
    if (revealIO) revealIO.disconnect();
    if (REDUCE || !('IntersectionObserver' in window)) items.forEach(function (n) { n.classList.add('in'); });
    else {
      revealIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (n) { revealIO.observe(n); });
    }
    var cv = el.results.querySelector('#ipq-bloom');
    if (!cv || REDUCE) return;
    var ctx = cv.getContext('2d'), rect = cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = rect.width * d; cv.height = rect.height * d; ctx.setTransform(d, 0, 0, d, 0, 0);
    var cols = female ? [[157, 239, 236], [255, 158, 196], [245, 185, 66]] : [[157, 239, 236], [95, 211, 201], [245, 185, 66]];
    var ps = [], cx = rect.width / 2, cy = rect.height * 0.46;
    for (var k = 0; k < 120; k++) { var a = Math.random() * 6.283, v = 70 + Math.random() * 260; ps.push({ x: cx, y: cy, vx: Math.cos(a) * v, vy: Math.sin(a) * v * 0.6, r: 1.5 + Math.random() * 3, c: cols[k % 3] }); }
    var t0 = performance.now(), last = t0;
    (function f(now) {
      var t = (now - t0) / 1000, dt = Math.min(0.05, (now - last) / 1000); last = now;
      ctx.clearRect(0, 0, rect.width, rect.height);
      ps.forEach(function (p) { p.vx *= 1 - 1.6 * dt; p.vy *= 1 - 1.6 * dt; p.x += p.vx * dt; p.y += p.vy * dt;
        ctx.globalAlpha = Math.max(0, 1 - t / 1.8) * 0.9; ctx.drawImage(dot(p.c), p.x - p.r * 2, p.y - p.r * 2, p.r * 4, p.r * 4); });
      ctx.globalAlpha = 1;
      if (t < 1.85 && state.stage === 'results') requestAnimationFrame(f); else ctx.clearRect(0, 0, rect.width, rect.height);
    })(t0);
  }
  function sparks(btn) {
    if (REDUCE) return;
    for (var k = 0; k < 12; k++) { var sp = document.createElement('i'); sp.className = 'ipq-spark'; sp.style.setProperty('--a', (k * 30) + 'deg'); btn.appendChild(sp); }
    setTimeout(function () { btn.querySelectorAll('.ipq-spark').forEach(function (n) { n.remove(); }); }, 900);
  }

  /* --- cart (AJAX with native fallback) ------------------------ */
  function addToCart(ids, btn, fallback) {
    if (btn.classList.contains('is-busy')) return;
    var verified = ids.length > 0 && ids.every(function (id) { return Object.keys(P).some(function (h) { return canBuy(P[h]) && String(P[h].variantId) === String(id); }); });
    if (!verified) { toast('Tento produkt momentálně nelze přidat do košíku.'); return; }
    btn.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
      .then(function (res) { if (!res.ok) throw new Error('cart ' + res.status); return res.json(); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        btn.innerHTML = '<i class="ph-bold ph-check" aria-hidden="true"></i> Přidáno';
        sparks(btn);
        toast((COPY.ui && COPY.ui.added) || 'Přidáno do košíku');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          var n = quiz.querySelector('#ipq-cart-n'); n.textContent = c.item_count; n.classList.toggle('on', c.item_count > 0);
          n.classList.remove('bump'); void n.offsetWidth; n.classList.add('bump');
        }).catch(function () { /* The add succeeded; an unread cart count must not add it again. */ });
      })
      .catch(function () { btn.classList.remove('is-busy'); toast('Košík se nepodařilo ověřit. Před dalším přidáním prosím zkontrolujte košík.'); });
  }
  function toast(t) {
    var w = quiz.querySelector('#ipq-toast');
    w.querySelector('#ipq-toast-t').textContent = t;
    w.classList.add('on'); clearTimeout(w._t); w._t = setTimeout(function () { w.classList.remove('on'); }, 4200);
  }

  /* ============================================================ SKY (feeling scene) */
  var ORB_SVG = '<svg class="ipq-orb" viewBox="-130 -130 260 260" role="presentation">' +
    '<defs><radialGradient id="ipq-og" cx="38%" cy="32%" r="75%"><stop offset="0%" id="ipq-og1"/><stop offset="100%" id="ipq-og2"/></radialGradient>' +
    '<radialGradient id="ipq-oh" cx="50%" cy="50%" r="50%"><stop offset="60%" stop-color="#fff" stop-opacity="0"/><stop offset="100%" stop-color="#fff" stop-opacity=".9"/></radialGradient></defs>' +
    '<g id="ipq-halo"><circle r="98" fill="none" stroke="#ffe6a6" stroke-width="2"/><circle r="116" fill="none" stroke="#ffe6a6" stroke-width="1" stroke-dasharray="2 9"/></g>' +
    '<g id="ipq-cramps" stroke="#ffd1dc" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none">' +
    '<path d="M-110 -40 l14 8 l-8 10 l16 6"/><path d="M98 -58 l-12 10 l10 8 l-14 10"/><path d="M-30 104 l8 -14 l8 10 l8 -14"/></g>' +
    '<g id="ipq-orbg"><path id="ipq-body" fill="url(#ipq-og)"/><path id="ipq-shine" fill="url(#ipq-oh)" opacity=".18"/>' +
    '<g stroke="#2a1b2e" stroke-width="5" stroke-linecap="round" fill="none" opacity=".82">' +
    '<path id="ipq-bl"/><path id="ipq-br"/><path id="ipq-el"/><path id="ipq-er"/><path id="ipq-pl"/><path id="ipq-pr"/></g>' +
    '<path id="ipq-mouth" stroke="#2a1b2e" stroke-width="5" stroke-linecap="round" fill="rgba(60,20,30,.35)" fill-opacity="0" opacity=".85"/>' +
    '<ellipse id="ipq-ck1" cx="-42" cy="18" rx="12" ry="7" fill="#ff8fa3"/><ellipse id="ipq-ck2" cx="42" cy="18" rx="12" ry="7" fill="#ff8fa3"/></g>' +
    '<g id="ipq-stars" fill="#fff6d6"><path d="M0-8 2-2 8 0 2 2 0 8-2 2-8 0-2-2Z" transform="translate(-92 -78)"/><path d="M0-8 2-2 8 0 2 2 0 8-2 2-8 0-2-2Z" transform="translate(96 -50) scale(.7)"/>' +
    '<path d="M0-8 2-2 8 0 2 2 0 8-2 2-8 0-2-2Z" transform="translate(84 84) scale(.9)"/><path d="M0-8 2-2 8 0 2 2 0 8-2 2-8 0-2-2Z" transform="translate(-100 70) scale(.6)"/></g></svg>';

  var SKY = {
    top: ['#120a18', '#1a1222', '#1d2230', '#2f3c4e', '#5f7389', '#5f8fb3', '#2f7fc4', '#2b86d6', '#6f9fe0', '#f3a6b5'],
    mid: ['#3a1024', '#3b1a33', '#363c4f', '#4f5e70', '#8b9cad', '#97b9d1', '#6cb2e4', '#7cc4f0', '#f2c9a8', '#ffd49a'],
    bot: ['#5a1a2c', '#4f2a3d', '#4a5163', '#6d7a88', '#b5c1cc', '#cfe0ea', '#bfe3f6', '#e6f4ff', '#ffe7c2', '#fff3d9'],
    cloud: ['#3d2a36', '#4a3843', '#5d6271', '#7a8593', '#c3ccd5', '#e4ecf2', '#ffffff', '#ffffff', '#fff6ea', '#fff8ee'],
    shade: ['#160b12', '#1d1219', '#2d313d', '#47505d', '#8995a2', '#a9bccb', '#c9dcea', '#d4e6f3', '#f0c9a6', '#f6c6a0'],
    sun: ['#ff3b3b', '#ff5a4a', '#c8c8d8', '#d8dde6', '#f0f2f5', '#fff6dc', '#fff4cc', '#fff2c2', '#ffe1a0', '#ffd27a'],
    sunA: [0.3, 0.2, 0.05, 0.08, 0.18, 0.35, 0.55, 0.7, 0.86, 1],
    orbIn: ['#ff6b7d', '#ff7f87', '#c79bd6', '#aab4d6', '#cfd9e4', '#a9e3dc', '#9df0e0', '#c9f7d9', '#fff1b8', '#fffbe0'],
    orbOut: ['#8a0f2e', '#7d1d47', '#4b2a6b', '#454f78', '#6c8096', '#2c8f8b', '#17a19e', '#1fb38a', '#f0a93b', '#ffb341']
  };

  function Sky() {
    var cv = quiz.querySelector('#ipq-sky'), ctx = cv.getContext('2d');
    var layer = document.createElement('canvas'), lx = layer.getContext('2d');
    var W = 0, H = 0, DPR = 1, raf = 0, running = false, cur = 5, tgt = 5, t0 = 0, last = 0;
    var clouds = [], rain = [], sparks = [], bolt = null, flash = 0, nextBolt = 1.5, orb = null, nodes = {};
    function rand(a, b) { return a + Math.random() * (b - a); }
    function W0() { return window.innerWidth; }
    function sprite(w) {
      var c = document.createElement('canvas'), h = Math.round(w * 0.62); c.width = w; c.height = h;
      var g = c.getContext('2d'), n = 7 + (Math.random() * 4 | 0);
      for (var i = 0; i < n; i++) {
        var r = Math.min(rand(0.16, 0.3) * w, h * 0.48), x = rand(r, w - r), y = clamp(h - rand(r * 0.9, r * 1.6), r, h - r);
        var rg = g.createRadialGradient(x, y, r * 0.15, x, y, r);
        rg.addColorStop(0, 'rgba(255,255,255,.95)'); rg.addColorStop(0.62, 'rgba(255,255,255,.75)'); rg.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = rg; g.beginPath(); g.arc(x, y, r, 0, 6.283); g.fill();
      }
      g.globalCompositeOperation = 'destination-in';
      var m = g.createLinearGradient(0, 0, 0, h); m.addColorStop(0, 'rgba(0,0,0,0)'); m.addColorStop(0.22, '#000'); m.addColorStop(0.8, '#000'); m.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = m; g.fillRect(0, 0, w, h); g.globalCompositeOperation = 'source-over';
      return c;
    }
    function build() {
      DPR = Math.min(window.devicePixelRatio || 1, W0() < 600 ? 1.25 : 1.5);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = layer.width = Math.round(W * DPR); cv.height = layer.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0); lx.setTransform(DPR, 0, 0, DPR, 0, 0);
      var base = Math.max(W, 900);
      clouds = [];
      // band: 0 = storm ceiling, 1 = mid drifters, 2 = sea of clouds
      for (var i = 0; i < 7; i++) clouds.push({ band: 0, s: sprite(Math.round(base * rand(0.32, 0.5))), x: rand(-0.2, 1.1), y: rand(-0.12, 0.16), sp: rand(0.6, 1.2), a: rand(0.75, 1) });
      for (i = 0; i < 4; i++) clouds.push({ band: 1, s: sprite(Math.round(base * rand(0.18, 0.3))), x: rand(-0.1, 1.1), y: rand(0.2, 0.42), sp: rand(0.4, 0.8), a: rand(0.55, 0.85) });
      for (i = 0; i < 8; i++) clouds.push({ band: 2, s: sprite(Math.round(base * rand(0.34, 0.55))), x: rand(-0.25, 1.1), y: rand(0.6, 0.9), sp: rand(0.15, 0.4), a: rand(0.8, 1) });
      rain = []; for (i = 0; i < (W < 600 ? 110 : 170); i++) rain.push({ x: Math.random() * W, y: Math.random() * H, l: rand(12, 26), v: rand(0.8, 1.3) });
      sparks = []; for (i = 0; i < 60; i++) sparks.push({ x: Math.random() * W, y: Math.random() * H, r: rand(0.6, 2.2), v: rand(6, 22), ph: Math.random() * 6.28 });
    }
    function bindOrb(svg) {
      orb = svg; nodes = {};
      ['og1', 'og2', 'body', 'shine', 'bl', 'br', 'el', 'er', 'pl', 'pr', 'mouth', 'ck1', 'ck2', 'halo', 'cramps', 'stars', 'orbg'].forEach(function (id) { nodes[id] = svg.querySelector('#ipq-' + id); });
    }
    function blob(R, k, t) {
      var N = 16, pts = [], spike = Math.pow(1 - k, 2.2) * 0.2, wob = 0.018 + (1 - k) * 0.035;
      for (var i = 0; i < N; i++) {
        var a = i / N * 6.2832, j = (i % 2 ? spike : -spike * 0.55) * (0.8 + 0.2 * Math.sin(t * 9 + i));
        var r = R * (1 + j + wob * Math.sin(t * 1.4 + i * 1.7) + 0.012 * Math.sin(t * 2.2 + i * 3.1));
        pts.push([Math.cos(a) * r, Math.sin(a) * r * (1 - 0.05 * (1 - k))]);
      }
      var d = '', n = pts.length;
      for (i = 0; i < n; i++) {
        var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
        if (!i) d = 'M' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1);
        d += 'C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ' ' +
          (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ' ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
      }
      return d + 'Z';
    }
    function drawOrb(v, t) {
      if (!orb) return;
      var k = (v - 1) / 9, R = 74 * (1.1 - 0.16 * k);
      nodes.og1.setAttribute('stop-color', rgb(ramp(SKY.orbIn, v)));
      nodes.og2.setAttribute('stop-color', rgb(ramp(SKY.orbOut, v)));
      nodes.body.setAttribute('d', blob(R, k, t));
      nodes.shine.setAttribute('d', blob(R * 0.98, k, t));
      var shake = REDUCE ? 0 : Math.pow(1 - k, 3) * 3.2, fy = REDUCE ? 0 : (-k * 6 + Math.sin(t * 1.6) * k * 5);
      nodes.orbg.setAttribute('transform', 'translate(' + (shake * (Math.random() - 0.5)).toFixed(1) + ' ' + (fy + shake * (Math.random() - 0.5)).toFixed(1) + ')');
      // pain eyes (> <) fade out, arc eyes fade in
      var pain = clamp((0.32 - k) / 0.12, 0, 1), arc = clamp((k - 0.2) / 0.12, 0, 1);
      var c = -13 * clamp((k - 0.3) / 0.7, 0, 1) + 3 * (1 - clamp((k - 0.3) / 0.7, 0, 1));
      nodes.pl.setAttribute('d', 'M-36 -22 L-20 -12 L-36 -2'); nodes.pr.setAttribute('d', 'M36 -22 L20 -12 L36 -2');
      nodes.pl.setAttribute('opacity', pain); nodes.pr.setAttribute('opacity', pain);
      nodes.el.setAttribute('d', 'M-38 -10 Q-27 ' + (-10 + c).toFixed(1) + ' -16 -10'); nodes.er.setAttribute('d', 'M16 -10 Q27 ' + (-10 + c).toFixed(1) + ' 38 -10');
      nodes.el.setAttribute('opacity', arc); nodes.er.setAttribute('opacity', arc);
      var brow = clamp((0.6 - k) / 0.3, 0, 1), lift = 10 * (1 - k);
      nodes.bl.setAttribute('d', 'M-44 ' + (-30 + lift * 0.2).toFixed(1) + ' L-18 ' + (-34 - lift).toFixed(1)); nodes.br.setAttribute('d', 'M44 ' + (-30 + lift * 0.2).toFixed(1) + ' L18 ' + (-34 - lift).toFixed(1));
      nodes.bl.setAttribute('opacity', brow); nodes.br.setAttribute('opacity', brow);
      var m = -16 + 34 * k, wob = REDUCE ? 0 : Math.sin(t * 15) * 6 * Math.pow(1 - k, 3), y0 = 26 + 4 * (1 - k);
      var open = clamp((k - 0.82) / 0.18, 0, 1);
      nodes.mouth.setAttribute('d', 'M-20 ' + y0.toFixed(1) + ' C-8 ' + (y0 + m + wob).toFixed(1) + ' 8 ' + (y0 + m - wob).toFixed(1) + ' 20 ' + y0.toFixed(1) +
        (open ? ' C8 ' + (y0 + m * 0.42).toFixed(1) + ' -8 ' + (y0 + m * 0.42).toFixed(1) + ' -20 ' + y0.toFixed(1) + 'Z' : ''));
      nodes.mouth.setAttribute('fill-opacity', open);
      var blush = clamp((k - 0.55) / 0.35, 0, 1) * 0.55;
      nodes.ck1.setAttribute('opacity', blush); nodes.ck2.setAttribute('opacity', blush);
      var halo = clamp((k - 0.68) / 0.32, 0, 1);
      nodes.halo.setAttribute('opacity', (halo * 0.7).toFixed(2));
      nodes.halo.setAttribute('transform', 'scale(' + (1 + (REDUCE ? 0 : 0.04 * Math.sin(t * 2))).toFixed(3) + ') rotate(' + (REDUCE ? 0 : (t * 8) % 360).toFixed(1) + ')');
      var cr = clamp((0.32 - k) / 0.32, 0, 1);
      nodes.cramps.setAttribute('opacity', (cr * (REDUCE ? 1 : 0.55 + 0.45 * Math.sin(t * 22))).toFixed(2));
      var st = clamp((k - 0.8) / 0.2, 0, 1);
      nodes.stars.setAttribute('opacity', (st * (REDUCE ? 1 : 0.6 + 0.4 * Math.sin(t * 3))).toFixed(2));
    }
    function frame(now) {
      if (!running) return;
      var t = (now - t0) / 1000, dt = Math.min(0.05, (now - last) / 1000 || 0.016); last = now;
      cur += (tgt - cur) * (REDUCE ? 1 : 1 - Math.pow(0.0008, dt));
      var v = cur, k = (v - 1) / 9;
      // CSS variables for the overlay UI
      var m = rgb(ramp(SKY.mid, v)), lum = (function (c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; })(ramp(SKY.mid, v));
      quiz.style.setProperty('--mood', rgb(ramp(SKY.orbOut, v)));
      quiz.style.setProperty('--fg', lum > 0.52 ? '#14324a' : '#ffffff');
      var bright = lum > 0.52;
      quiz.style.setProperty('--glass', bright ? 'rgba(255,255,255,.72)' : 'rgba(255,255,255,.12)');
      quiz.style.setProperty('--glass-b', bright ? 'rgba(20,50,74,.14)' : 'rgba(255,255,255,.22)');
      quiz.style.setProperty('--halo', bright ? 'rgba(255,255,255,.85)' : 'rgba(8,10,20,.5)');
      quiz.style.setProperty('--cta-bg', bright ? '#0a5c59' : 'rgba(255,255,255,.94)');
      quiz.style.setProperty('--cta-fg', bright ? '#fff' : '#0f2a3d');
      // sky
      var g = ctx.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, rgb(ramp(SKY.top, v))); g.addColorStop(0.55, m); g.addColorStop(1, rgb(ramp(SKY.bot, v)));
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      // sun glow + disc
      var sx = W * 0.5, sy = H * 0.6, sa = SKY.sunA[Math.min(9, Math.floor(v - 1))] + (SKY.sunA[Math.min(9, Math.ceil(v - 1))] - SKY.sunA[Math.min(9, Math.floor(v - 1))]) * ((v - 1) % 1);
      var sc = ramp(SKY.sun, v), rad = Math.max(W, H) * (0.45 + 0.25 * k);
      var sg = ctx.createRadialGradient(sx, sy, 0, sx, sy, rad);
      sg.addColorStop(0, rgb(sc, sa)); sg.addColorStop(0.25, rgb(sc, sa * 0.45)); sg.addColorStop(1, rgb(sc, 0));
      ctx.fillStyle = sg; ctx.fillRect(0, 0, W, H);
      var disc = clamp((v - 6.4) / 3.6, 0, 1);
      if (disc > 0) { ctx.fillStyle = rgb([255, 252, 238], disc * 0.95); ctx.beginPath(); ctx.arc(sx, sy, 16 + 26 * disc, 0, 6.283); ctx.fill(); }
      // god rays
      var gr = clamp((v - 7.4) / 2.6, 0, 1);
      if (gr > 0) {
        ctx.save(); ctx.translate(sx, sy); ctx.rotate(REDUCE ? 0 : t * 0.03); ctx.globalCompositeOperation = 'lighter';
        for (var i = 0; i < 16; i++) {
          ctx.rotate(6.283 / 16);
          var rg = ctx.createLinearGradient(0, 0, 0, -rad); rg.addColorStop(0, rgb(sc, 0.12 * gr)); rg.addColorStop(1, rgb(sc, 0));
          ctx.fillStyle = rg; ctx.beginPath(); ctx.moveTo(-8, 0); ctx.lineTo(-rad * 0.09, -rad); ctx.lineTo(rad * 0.09, -rad); ctx.lineTo(8, 0); ctx.fill();
        }
        ctx.restore();
      }
      // clouds: white sprites → one tinted layer
      var wind = REDUCE ? 0 : (0.004 + Math.pow(1 - k, 1.5) * 0.05);
      lx.clearRect(0, 0, W, H);
      var ceil = clamp((6.2 - v) / 5, 0, 1), seaA = 0.55 + 0.45 * k;
      for (i = 0; i < clouds.length; i++) {
        var cl = clouds[i], a = cl.a * (cl.band === 0 ? ceil : cl.band === 2 ? seaA : 0.75);
        if (a < 0.02) { cl.x += wind * cl.sp * dt; continue; }
        cl.x += wind * cl.sp * dt * (cl.band === 2 ? 0.35 : 1);
        var cw = cl.s.width, ch = cl.s.height;
        if (cl.x * W > W + 40) cl.x = -cw / W - 0.05;
        var yy = cl.y * H + (cl.band === 0 ? (1 - k) * H * 0.06 : 0) + (cl.band === 2 ? (1 - k) * H * 0.05 : 0);
        lx.globalAlpha = a; lx.drawImage(cl.s, cl.x * W, yy - ch / 2, cw, ch);
      }
      lx.globalAlpha = 1; lx.globalCompositeOperation = 'source-atop';
      var cg = lx.createLinearGradient(0, 0, 0, H), cb = ramp(SKY.cloud, v), cs = ramp(SKY.shade, v);
      cg.addColorStop(0, rgb(cs)); cg.addColorStop(0.42, rgb(mix(cs, cb, 0.75))); cg.addColorStop(0.7, rgb(cb)); cg.addColorStop(1, rgb(mix(cb, [255, 255, 255], 0.25)));
      lx.fillStyle = cg; lx.fillRect(0, 0, W, H); lx.globalCompositeOperation = 'source-over';
      ctx.drawImage(layer, 0, 0, W, H);
      // rain
      var ri = clamp((4.6 - v) / 3.6, 0, 1), rn = Math.round(rain.length * ri);
      if (rn) {
        ctx.strokeStyle = 'rgba(205,215,235,' + (0.18 + 0.22 * ri).toFixed(2) + ')'; ctx.lineWidth = 1.2; ctx.beginPath();
        var slant = 3 + 9 * ri;
        for (i = 0; i < rn; i++) {
          var d = rain[i];
          if (!REDUCE) { d.y += d.v * (520 + 380 * ri) * dt; d.x += slant * 18 * dt; if (d.y > H) { d.y = -d.l; d.x = Math.random() * W; } if (d.x > W) d.x -= W; }
          ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - slant, d.y - d.l);
        }
        ctx.stroke();
      }
      // lightning
      if (v < 2.6 && !REDUCE) {
        nextBolt -= dt;
        if (nextBolt <= 0) {
          nextBolt = rand(1.4, 3.6) * (1 + (v - 1)); flash = 0.55 * (1 - (v - 1) / 1.6 * 0.5);
          var bx = rand(0.12, 0.88) * W, by = 0, pts = [[bx, by]];
          while (by < H * rand(0.38, 0.6)) { bx += rand(-38, 38); by += rand(22, 48); pts.push([bx, by]); }
          bolt = { pts: pts, life: 0.22 };
        }
      }
      if (flash > 0.005) { ctx.fillStyle = 'rgba(232,222,255,' + flash.toFixed(3) + ')'; ctx.fillRect(0, 0, W, H); flash *= Math.pow(0.0005, dt); }
      if (bolt && bolt.life > 0) {
        bolt.life -= dt;
        ctx.save(); ctx.lineJoin = 'round';
        [[9, 'rgba(200,170,255,.18)'], [3.5, 'rgba(240,230,255,.75)'], [1.4, '#fff']].forEach(function (s) {
          ctx.strokeStyle = s[1]; ctx.lineWidth = s[0]; ctx.beginPath();
          bolt.pts.forEach(function (p, j) { if (j) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); }); ctx.stroke();
        });
        ctx.restore();
      }
      // sparkles (seventh heaven)
      var spk = clamp((v - 7.6) / 2.4, 0, 1);
      if (spk > 0) {
        for (i = 0; i < sparks.length; i++) {
          var s = sparks[i];
          if (!REDUCE) { s.y -= s.v * dt; if (s.y < -4) { s.y = H + 4; s.x = Math.random() * W; } }
          var tw = 0.45 + 0.55 * Math.sin(t * 2.4 + s.ph);
          ctx.fillStyle = 'rgba(255,246,214,' + (spk * tw * 0.9).toFixed(2) + ')'; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.283); ctx.fill();
        }
      }
      // vignette
      var vg = Math.pow(1 - k, 1.5) * 0.6;
      if (vg > 0.01) {
        var vgr = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.3, W / 2, H / 2, Math.max(W, H) * 0.75);
        vgr.addColorStop(0, 'rgba(10,0,8,0)'); vgr.addColorStop(1, 'rgba(10,0,8,' + vg.toFixed(2) + ')'); ctx.fillStyle = vgr; ctx.fillRect(0, 0, W, H);
      }
      drawOrb(v, t);
      raf = requestAnimationFrame(frame);
    }
    var onResize = function () { if (running) build(); };
    build();
    window.addEventListener('resize', onResize);
    return {
      start: function (svg, v) { bindOrb(svg); cur = tgt = v; if (!running) { running = true; t0 = last = performance.now(); raf = requestAnimationFrame(frame); } },
      target: function (v) { tgt = v; },
      stop: function () { running = false; cancelAnimationFrame(raf); }
    };
  }

  /* ============================================================ SWIRL (analysis) */
  function Swirl(cv) {
    var ctx = cv.getContext('2d'), raf = 0, on = false, ps = [], t0 = 0, female = false;
    function size() { var r = cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); cv.width = r.width * d; cv.height = r.height * d; ctx.setTransform(d, 0, 0, d, 0, 0); return r; }
    function frame(now) {
      if (!on) return;
      var r = cv.getBoundingClientRect(), w = r.width, h = r.height, cx = w / 2, cy = h / 2, t = (now - t0) / 1000;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        p.a += p.s * (0.45 + t * 0.12) * 0.016; p.d -= p.d * (0.12 + t * 0.06) * 0.016;
        if (p.d < 18) { p.d = rnd(w * 0.36, w * 0.5); }
        var x = cx + Math.cos(p.a) * p.d, y = cy + Math.sin(p.a) * p.d * 0.92;
        ctx.fillStyle = p.c; ctx.globalAlpha = Math.min(1, (p.d - 18) / 40) * 0.9;
        ctx.beginPath(); ctx.arc(x, y, p.r, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }
    function rnd(a, b) { return a + Math.random() * (b - a); }
    return {
      start: function (fem) {
        female = fem; var r = size(); ps = [];
        var cols = female ? ['#9defec', '#5fd3c9', '#ff9ec4', '#f5b942'] : ['#9defec', '#5fd3c9', '#c9f7d9', '#f5b942'];
        for (var i = 0; i < 140; i++) ps.push({ a: Math.random() * 6.283, d: rnd(r.width * 0.2, r.width * 0.5), s: rnd(1.2, 3.2) * (Math.random() < 0.5 ? 1 : 1), r: rnd(1, 3.2), c: cols[i % cols.length] });
        if (REDUCE) return;
        on = true; t0 = performance.now(); cancelAnimationFrame(raf); raf = requestAnimationFrame(frame);
      },
      stop: function () { on = false; cancelAnimationFrame(raf); }
    };
  }

  /* ============================================================ boot */
  quiz.querySelector('#ipq-start').addEventListener('click', start);
  quiz.querySelector('#ipq-skip').addEventListener('click', function () { track('quiz_email_skipped'); renderResults(); });
  quiz.querySelector('#ipq-email-back').addEventListener('click', function () { state.path.pop(); renderQuestion(); });
  var form = quiz.querySelector('#ipq-form');
  form.querySelector('[name="return_to"]').value = location.pathname + location.search;
  // Native Shopify submit preserves its hCaptcha and error handling; no fake success response.
  form.addEventListener('submit', function () { state.stage = 'submitted'; save(); track('quiz_email_submitted'); });
  try {
    var raw = sessionStorage.getItem(KEY);
    if (raw) {
      var saved = JSON.parse(raw);
      if (saved && saved.profile && Array.isArray(saved.path)) state = saved;
    }
    if (form.querySelector('[data-form-error]')) { showEmail(); return; }
    if (state.profileStep === 3) {
      if (!tree.question(state.profile, state.path)) {
        if (state.stage === 'results' || state.stage === 'submitted' || form.querySelector('[data-posted]')) renderResults();
        else if (state.stage === 'loading') analyze();
        else showEmail();
        return;
      }
      renderQuestion(); return;
    }
    if (state.stage !== 'intro' && state.profileStep >= 0 && state.profileStep < 3) { renderProfile(); return; }
  } catch (e) {
    state = fresh();
  }
  show('intro', 0, 'dark');
})();
